export var LogLevel;
(function (LogLevel) {
    LogLevel["None"] = "none";
    LogLevel["Fatal"] = "fatal";
    LogLevel["Error"] = "error";
    LogLevel["Warning"] = "warning";
    LogLevel["Info"] = "info";
    LogLevel["Debug"] = "debug";
})(LogLevel || (LogLevel = {}));
export var LogLevelNumber;
(function (LogLevelNumber) {
    LogLevelNumber[LogLevelNumber["None"] = 1] = "None";
    LogLevelNumber[LogLevelNumber["Fatal"] = 2] = "Fatal";
    LogLevelNumber[LogLevelNumber["Error"] = 3] = "Error";
    LogLevelNumber[LogLevelNumber["Warning"] = 4] = "Warning";
    LogLevelNumber[LogLevelNumber["Info"] = 5] = "Info";
    LogLevelNumber[LogLevelNumber["Debug"] = 6] = "Debug";
})(LogLevelNumber || (LogLevelNumber = {}));
export const logLevelNumberToString = {
    [LogLevelNumber.None]: LogLevel.None,
    [LogLevelNumber.Fatal]: LogLevel.Fatal,
    [LogLevelNumber.Error]: LogLevel.Error,
    [LogLevelNumber.Warning]: LogLevel.Warning,
    [LogLevelNumber.Info]: LogLevel.Info,
    [LogLevelNumber.Debug]: LogLevel.Debug,
};
export const logLevelStringToNumber = {
    [LogLevel.None]: LogLevelNumber.None,
    [LogLevel.Fatal]: LogLevelNumber.Fatal,
    [LogLevel.Error]: LogLevelNumber.Error,
    [LogLevel.Warning]: LogLevelNumber.Warning,
    [LogLevel.Info]: LogLevelNumber.Info,
    [LogLevel.Debug]: LogLevelNumber.Debug,
};
//# sourceMappingURL=types.js.map